import React from 'react'
import { withAsync } from '@/components/Async'
import type { RouteConfig } from 'react-router-config'
import { OwSet } from '@yy/one-icon'
import { withRedirect } from '@/components/Authorization'
import Blank from '@/layouts/Blank'

const routes: RouteConfig[] = [
  {
    name: 'setting',
    menuTitle: 'shipSetting.title',
    path: '/setting',
    component: withRedirect(Blank),
    // component: withAsync(() => import(/* webpackChunkName: "Setting" */ '@/containers/Setting/Index')),
    icon: <OwSet />,
    // exact: true,
    authCode: 'settings',
    routes: [
      {
        menuTitle: 'menu.saleSetting', // 销售平台设置
        path: '/sale',
        component: withAsync(() => import(/* webpackChunkName: "Setting" */ '@/containers/Setting/Sale')),
        exact: true,
      },
      {
        menuTitle: 'menu.shipSetting', // 出货设置
        path: '/ship',
        component: withAsync(() => import(/* webpackChunkName: "Setting" */ '@/containers/Setting/Ship')),
        exact: true,
      },
      {
        menuTitle: 'logistic.match.setting', // 物流设置
        component: withAsync(() => import('@/containers/Setting/PreferenceLogistic')),
        path: '/preferenceLogistic',
        exact: true,
      },
      {
        name: 'stockManagement',
        component: withAsync(() => import('@/containers/Setting/StockManagement')),
        path: '/stockManagement',
        parentKeys: ['/setting/sale'],
        hideInMenu: true,
        menuTitle: '库存同步规则',
        exact: true,
      },
      {
        menuTitle: 'menu.noticeSetting', // 通知设置
        path: '/notice',
        component: withAsync(() => import(/* webpackChunkName: "Setting" */ '@/containers/Setting/Notice')),
        exact: true,
      },
      {
        menuTitle: 'setting.noticeSetting.emailTemplateSettings', // email settings
        path: '/email/:type',
        component: withAsync(() => import(/* webpackChunkName: "Setting" */ '@/containers/Setting/EmailSetting')),
        exact: true,
        hideInMenu: true,
      },
      {
        menuTitle: 'menu.emsSetting', // 短信充值设置
        path: '/subscribe',
        component: withRedirect(Blank),
        routes: [
          {
            path: '/',
            component: withAsync(() => import('@/containers/Setting/Subscribe')),
            exact: true,
          },
          {
            path: '/pay',
            component: withAsync(() => import('@/containers/Setting/Subscribe/Pay')),
            exact: true,
          },
          {
            path: '/bills',
            exact: true,
            component: withAsync(() => import('@/containers/Setting/Subscribe/BillRecord')),
          },
        ],
      },
      {
        menuTitle: 'menu.otherSetting', // 附加功能设置
        path: '/other',
        component: withAsync(() => import(/* webpackChunkName: "Setting" */ '@/containers/Setting/Other')),
        exact: true,
      },
      {
        name: 'safetyStockSetting',
        menuTitle: '安全库存设置',
        component: withAsync(() => import(/* webpackChunkName: "safetyStockSetting" */ '@/containers/Setting/SafetyStock')),
        exact: true,
        hideInMenu: true,
        path: '/safetyStock',
        parentKeys: ['/setting/other'],
      },
      {
        name: 'addressBook',
        menuTitle: 'common.addressBook', // 地址簿
        component: withAsync(() => import(/* webpackChunkName: "addressBook" */ '@/containers/Setting/AddressBook')),
        exact: true,
        path: '/addressBook',
      },
      {
        name: 'freebiesSetting',
        menuTitle: '',
        component: withAsync(() => import(/* webpackChunkName: "freebiesSetting" */ '@/containers/Setting/FreebiesSetting')),
        exact: true,
        hideInMenu: true,
        path: '/freebiesSetting',
        parentKeys: ['/setting/other'],
      },
      {
        name: 'freebiesSettingDetail',
        menuTitle: '',
        component: withAsync(() => import(/* webpackChunkName: "freebiesSetting" */ '@/containers/Setting/FreebiesSetting/detail')),
        exact: true,
        hideInMenu: true,
        path: '/freebiesSetting/:id',
        parentKeys: ['/setting/other'],
      },
    ],
  },
]

export default routes
